const indexItems = [
  { title: '电影专区', desc: '最新院线大片、经典电影全集', icon: 'ri-film-line', count: '8000+' },
  { title: '电视剧场', desc: '国产剧、韩剧、美剧、日剧全覆盖', icon: 'ri-tv-line', count: '12000+' },
  { title: '综艺娱乐', desc: '热门综艺、搞笑节目实时更新', icon: 'ri-emotion-laugh-line', count: '3000+' },
  { title: '动漫番剧', desc: '日漫国漫热门连载一网打尽', icon: 'ri-anchor-line', count: '5000+' },
  { title: '纪录片库', desc: '自然、历史、科技纪录片精选', icon: 'ri-earth-line', count: '2000+' },
  { title: '短剧频道', desc: '精彩短剧爽看不停', icon: 'ri-flashlight-line', count: '1500+' },
  { title: '排行榜单', desc: '热门排行、高分推荐、新片速递', icon: 'ri-bar-chart-2-line', count: '实时' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center">
          内容索引
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">影视内容分类快速导航</p>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#media"
              className="group flex flex-col items-center text-center p-5 md:p-6 bg-background-50 rounded-2xl hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className={`${item.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900 font-heading">
                {item.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
              <span className="mt-2 text-xs font-medium text-primary-600 bg-primary-100 px-2 py-0.5 rounded-full group-hover:bg-primary-200 transition-colors">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}